import React, { createContext, FC, useContext } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { OrganizationContext } from './OrganizationContext';

interface ILiveRegionContext {
  region: string;
  setRegion: (value: string) => void;
}

export const LiveRegionContext = createContext<ILiveRegionContext>({
  region: '',
  setRegion: () => void 0,
});

export const LiveRegionContextProvider: FC<{ identifier?: string }> = ({ identifier, children }) => {
  const { organizationId } = useContext(OrganizationContext);

  const [region, setRegion] = useLocalStorage(`liveRegion-${identifier ?? organizationId}`, '');

  return <LiveRegionContext.Provider value={{ region, setRegion }}>{children}</LiveRegionContext.Provider>;
};
